import { createSlice } from "@reduxjs/toolkit";
import {
  authLogin,
  authRegister,
  fetchProfile,
  updateProfile,
  deleteAddress,
  fetchBotTypes,
  fetchAddresses,
  changePassword,
  acceptInvitaion,
  rejectInvitaion,
  fetchCourseList,
  authLoginCallback,
  authForgotPassword,
  authUpdateMemberDetails,
  fetchClassesInvitations,
  fetchWeightClassCategories,
  CreateBot,
  updateBot,
  DeleteTeam,
  DeleteBot,
  fetchTeamMember,
  fetchCourseAssignmentList,
} from "../action/authAction";
import { pipSaveProfile } from "../../utils/pip";

const initialState = {
  isLoading: false,
  isToggle: false,
  botTypes: [],
  courseList: [],
  courseAssignmentList: [],
  addressList: [],
  profileDetail: {},
  invitationsList: [],
  weightClassCategories: [],
};

export const authSlice = createSlice({
  name: "Auth",
  initialState: initialState,
  reducers: {
    toggleChange: (state, action) => {
      state.isToggle = action?.payload;
    },
  },
  extraReducers: (builder) => {
    // auth-register
    builder.addCase(authRegister.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authRegister.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authRegister.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-login
    builder.addCase(authLogin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authLogin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authLogin.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-forgot-password
    builder.addCase(authForgotPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authForgotPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authForgotPassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-profile
    builder.addCase(fetchProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? {};
      if (success) {
        pipSaveProfile(data ?? null);
      }
      state.profileDetail = data ?? {};
      state.isLoading = false;
    });
    builder.addCase(fetchProfile.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-addresses
    builder.addCase(fetchAddresses.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAddresses.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? {};
      state.addressList = data?.user_addresses ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchAddresses.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-change-password
    builder.addCase(changePassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    // update-profile
    builder.addCase(updateProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-address
    builder.addCase(deleteAddress.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteAddress.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteAddress.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-invitaitons-list
    builder.addCase(fetchClassesInvitations.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchClassesInvitations.fulfilled, (state, action) => {
      const { invitations } = action?.payload ?? {};
      state.invitationsList = invitations ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchClassesInvitations.rejected, (state, action) => {
      state.isLoading = false;
    });

    // reject-invitation
    builder.addCase(rejectInvitaion.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(rejectInvitaion.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(rejectInvitaion.rejected, (state, action) => {
      state.isLoading = false;
    });
    // accept-invitation
    builder.addCase(acceptInvitaion.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(acceptInvitaion.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(acceptInvitaion.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-course-list
    builder.addCase(fetchCourseList.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCourseList.fulfilled, (state, action) => {
      const { courses } = action?.payload ?? {};
      state.courseList = courses ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchCourseList.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-course-assignment-list
    builder.addCase(fetchCourseAssignmentList.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCourseAssignmentList.fulfilled, (state, action) => {
      const {assignments  } = action?.payload ?? {};
      state.courseAssignmentList = assignments ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchCourseAssignmentList.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-login-callback
    builder.addCase(authLoginCallback.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authLoginCallback.fulfilled, (state, action) => {
      const { user } = action.payload ?? {};
      pipSaveProfile(user ?? {});
      state.isLoading = false;
    });
    builder.addCase(authLoginCallback.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-update-member-detail
    builder.addCase(authUpdateMemberDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authUpdateMemberDetails.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authUpdateMemberDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-bot-types
    builder.addCase(fetchBotTypes.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBotTypes.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.botTypes = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchBotTypes.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-wieght-class-categories
    builder.addCase(fetchWeightClassCategories.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWeightClassCategories.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.weightClassCategories = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchWeightClassCategories.rejected, (state, action) => {
      state.isLoading = false;
    });

    // create-bot
    builder.addCase(CreateBot.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(CreateBot.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(CreateBot.rejected, (state, action) => {
      state.isLoading = false;
    });

    // update-bot
    builder.addCase(updateBot.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateBot.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateBot.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-team
    builder.addCase(DeleteTeam.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(DeleteTeam.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(DeleteTeam.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-bot
    builder.addCase(DeleteBot.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(DeleteBot.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(DeleteBot.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-team-member
    builder.addCase(fetchTeamMember.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTeamMember.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.user = data;
      state.isLoading = false;
    });
    builder.addCase(fetchTeamMember.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { toggleChange } = authSlice.actions;
export default authSlice.reducer;
